// @flow
import client from '../../client'
import format from '../../utils/format'

// Types
import type { PaypalAccount } from './register'

// API Endpoints
export const WITHDRAW_PAYPAL_ACCOUNT_ENDPOINT =
  '/travel_agent/paypal_account/{0}/withdraw/'

/**
 * Withdrawl to paypal account
 * @param {Object} data Withdrawl information
 * @param {number} data.account_id Paypal account ID
 * @param {number} data.month Withdrawl month
 * @param {number} data.year Withdrawl year
 * @return {Promise|Error} A resolved Promise with the paypal account updated or Rejected with an Error
 */
export const withdrawToPaypalAccount = (data: {
  account_id: number,
  month: number,
  year: number,
}): Promise<PaypalAccount> => {
  const { account_id, month, year } = data
  const endpoint = format(WITHDRAW_PAYPAL_ACCOUNT_ENDPOINT, account_id)

  return client.post(endpoint, { body: { month, year } })
}

export default withdrawToPaypalAccount
